import { Link } from "react-router-dom";
import { footerLinks, CONTACT_EMAIL } from "../data/phase3Content";
import { useGoToSection } from "../lib/useGoToSection";

export const Footer = () => {
  const goTo = useGoToSection();
  return (
    <footer className="bg-[#08090D] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 pb-[calc(env(safe-area-inset-bottom,0px)+32px)] pt-14 md:grid-cols-[1.3fr_1fr_1fr] lg:px-10">
        <div>
          <p className="text-[18px] font-extrabold tracking-[-0.02em]">SOCIAL<span className="text-[#A79DE2]"> AI</span></p>
          <p className="mt-3 max-w-[300px] text-[14px] leading-relaxed text-white/60">Stories spark conversations. AI brings people closer.</p>
        </div>
        <nav aria-label="Product">
          <p className="text-[12px] font-semibold text-white/55">Product</p>
          <ul className="mt-3 space-y-2">
            {footerLinks.map((l) => (
              <li key={l.id}>
                <a href={`/#${l.id}`} onClick={(e) => { e.preventDefault(); goTo(l.id); }} data-testid={`footer-${l.id}-link`} className="text-[14px] text-white/80 transition-colors hover:text-white">{l.label}</a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="text-[12px] font-semibold text-white/55">Company</p>
          <ul className="mt-3 space-y-2 text-[14px]">
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-white/80 hover:text-white">Privacy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="text-white/80 hover:text-white">Terms</Link></li>
            <li><a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-link" className="break-all text-white/80 hover:text-white">{CONTACT_EMAIL}</a></li>
          </ul>
        </div>
      </div>
      <div className="mx-auto max-w-[1240px] border-t border-white/10 px-5 py-5 text-[12px] text-white/60 lg:px-10">© 2026 Social AI</div>
    </footer>
  );
};
